// WebSocket push notification utility for super-admin-ui
// Sends notifications to connected POS terminals via pos-websocket-service

declare const __PRODUCT_CONFIG__: { id: string } | undefined;

type Stage = 'prod' | 'staging' | 'dev';

const detectStage = (): Stage => {
  try {
    const viteStage = typeof import.meta !== 'undefined' ? (import.meta as any)?.env?.VITE_STAGE : '';
    if (viteStage === 'prod' || viteStage === 'staging' || viteStage === 'dev') return viteStage;
  } catch (_) { /* ignore */ }
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  if (hostname.includes('dev.')) return 'dev';
  if (hostname.includes('staging.') || hostname.includes('stage.')) return 'staging';
  if (hostname === 'localhost' || hostname === '127.0.0.1') return 'dev';
  return 'prod';
};

type ProductId = 'cafemaster' | 'agenticpos' | 'agenticrealestate';
const domainMap: Record<ProductId, Record<Stage, string>> = {
  cafemaster: { prod: 'coffeemasterpro.com', staging: 'staging.coffeemasterpro.com', dev: 'dev.coffeemasterpro.com' },
  agenticpos: { prod: 'rubytill.com', staging: 'stage.rubytill.com', dev: 'dev.rubytill.com' },
  agenticrealestate: { prod: 'terrakron.com', staging: 'stage.terrakron.com', dev: 'dev.terrakron.com' },
};

const getProductId = (): ProductId => {
  // Super admin uses hostname detection
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  if (hostname.includes('rubytill') || hostname.includes('agenticpos')) return 'agenticpos';
  if (hostname.includes('terrakron') || hostname.includes('agenticrealestate')) return 'agenticrealestate';
  if (typeof __PRODUCT_CONFIG__ !== 'undefined' && __PRODUCT_CONFIG__?.id) return __PRODUCT_CONFIG__.id as ProductId;
  return 'cafemaster';
};

function getWsServiceUrl(): string {
  const stage = detectStage();
  const base = domainMap[getProductId()][stage];
  return `https://pos-ws.api.${base}`;
}

function getToken(): string | null {
  return localStorage.getItem('jwtToken');
}

export async function pushNotify(
  type: string,
  target: { tenantId: string; locationId?: string; terminalId?: string },
  payload?: Record<string, unknown>,
): Promise<void> {
  const token = getToken();
  if (!token) return;

  try {
    const res = await fetch(`${getWsServiceUrl()}/notify`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        ...(target.tenantId && { 'x-tenant-id': target.tenantId }),
      },
      body: JSON.stringify({ type, target, payload }),
    });
    if (!res.ok) {
      console.warn(`[pushNotify] Failed: ${res.status}`);
    }
  } catch (err) {
    console.warn('[pushNotify] Error:', err);
  }
}
